module.exports = __webpack_public_path__ + "static/media/icon_check-sm.00914d7c.svg";